
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as MapActions from '../../../Mars/Map/map.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'
import * as IndicatorsActions from '../../../Mars/Indicators/indicators.actions'
import * as battlesActions from '../../../Mars/Battles/battles.actions'

import * as MapSelectors from '../../../Mars/Map/map.selectors'

import * as tutorialActions from '../../tutorial.actions'

import * as tutorialSelectors from '../../tutorial.selectors'

import { seeds } from '../../../Mars/Map/seeds'

import View from '../../../Mars/Map/MapScreen/View/View'

const mapDispatchToProps = (dispatch) => ({
  selectCurrentTile: bindActionCreators(MapActions.selectCurrentTile, dispatch),
  clearSprites: bindActionCreators(MapActions.clearSprites, dispatch),
  setDisplayType: bindActionCreators(IndicatorsActions.setDisplayType, dispatch),
  mapLoaded: bindActionCreators(MapActions.mapLoaded, dispatch),
  mapLoadError: bindActionCreators(MapActions.mapLoadError, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  getBattle: bindActionCreators(battlesActions.getBattle, dispatch),

  addPopup: bindActionCreators(tutorialActions.clickTile, dispatch),
})

const mapStateToProps = (state) => ({
  // No need to mock
  seeds: seeds,
  zoomLevels: MapSelectors.getZooms(state),
  allAnimations: MapSelectors.getAnimations(state),
  terrainAtlas: MapSelectors.getAtlas(state),

  // TODO TUTORIAL mock visitor map
  visitorMap: tutorialSelectors.getVisitorMap(state),
  visitorInfo: tutorialSelectors.getVisitorInfo(state),
  listenerType: tutorialSelectors.getCurrentStore(state),

  userMap: tutorialSelectors.getUserMap(state),
  phaseInfo: tutorialSelectors.getPhasesInfo(state),
  hideRanking: !tutorialSelectors.getMapUI(state).ranking,
  hideZoom: !tutorialSelectors.getMapUI(state).zoom,
  isTutorial: tutorialSelectors.isTutorialMode(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(View)
